function isKnownLocalAssetPath(rawValue) {
	return rawValue.startsWith('file://')
		|| rawValue.startsWith('wxfile://')
		|| rawValue.startsWith('content://')
		|| rawValue.startsWith('cdvfile://')
		|| rawValue.startsWith('_doc/')
		|| rawValue.startsWith('_downloads/')
		|| rawValue.startsWith('/storage/')
		|| rawValue.startsWith('/private/')
		|| rawValue.startsWith('/var/')
		|| rawValue.startsWith('/Users/')
		|| rawValue.startsWith('/tmp/');
}

export function normalizeProtectedAssetPath(input) {
	const rawValue = String(input || '').trim();
	if (!rawValue) {
		return '';
	}
	if (/^https?:\/\//i.test(rawValue)
		|| rawValue.startsWith('blob:')
		|| rawValue.startsWith('data:')
		|| isKnownLocalAssetPath(rawValue)) {
		return rawValue;
	}
	return rawValue.startsWith('/') ? rawValue : `/${rawValue}`;
}

export function isPersistedProtectedAssetPath(input) {
	const normalized = String(input || '').trim();
	if (!normalized) {
		return false;
	}
	const pathLike = normalized.split('?')[0].split('#')[0].trim().toLowerCase();
	return pathLike.endsWith('.bxo');
}
